import all /*           */ from 'ramda/es/all'
import any /*           */ from 'ramda/es/any'
import chain /*         */ from 'ramda/es/chain'
import compose /*       */ from 'ramda/es/compose'
import concat /*        */ from 'ramda/es/concat'
import equals /*        */ from 'ramda/es/equals'
import filter /*        */ from 'ramda/es/filter'
import fromPairs /*     */ from 'ramda/es/fromPairs'
import has /*           */ from 'ramda/es/has'
import identity /*      */ from 'ramda/es/identity'
import is /*            */ from 'ramda/es/is'
import isEmpty /*       */ from 'ramda/es/isEmpty'
import keys /*          */ from 'ramda/es/keys'
import lensProp /*      */ from 'ramda/es/lensProp'
import map /*           */ from 'ramda/es/map'
import mapObjIndexed /* */ from 'ramda/es/mapObjIndexed'
import mergeWith /*     */ from 'ramda/es/mergeWith'
import negate /*        */ from 'ramda/es/negate'
import not /*           */ from 'ramda/es/not'
import nthArg /*        */ from 'ramda/es/nthArg'
import pickBy /*        */ from 'ramda/es/pickBy'
import pipe /*          */ from 'ramda/es/pipe'
import prop /*          */ from 'ramda/es/prop'
import range /*         */ from 'ramda/es/range'
import set /*           */ from 'ramda/es/set'
import sort /*          */ from 'ramda/es/sort'
import sortBy /*        */ from 'ramda/es/sortBy'
import sum /*           */ from 'ramda/es/sum'
import toPairs /*       */ from 'ramda/es/toPairs'
import values /*        */ from 'ramda/es/values'

export default {
  all,
  any,
  chain,
  compose,
  concat,
  equals,
  filter,
  fromPairs,
  has,
  identity,
  is,
  isEmpty,
  keys,
  lensProp,
  map,
  mapObjIndexed,
  mergeWith,
  negate,
  not,
  nthArg,
  pickBy,
  pipe,
  prop,
  range,
  set,
  sort,
  sortBy,
  sum,
  toPairs,
  values,
}



// WEBPACK FOOTER //
// ./src/ramda.js